import Ajax from '@/lib/ajax'

export default {
  getList(
    pageSize: number,
    currentPage: number,
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    return Ajax.get('/api/MallConfigManagement/PCHomeTemplate', {
      params: params
    })
  }
}